
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gyC9Y9TMnQFszyqzkxzgWQ0sxjpQtmCgjfN51D3_met8Meta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexLuhwRoMCtvMkhx8MHUJCQmVQJnv038fPkfEYH_xpDSEMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchHIJWBJADRV7I_45nUKj36DVdOBEbb0G_hgp975jybvV_45gMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index7TsGI8to2zEfgO5uO19aWO8_45nEx9qpLFxwSvLJkX4NgMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_933pszaalY_455WbXlNIUYExyPexwcjJuh7RtMAt0OcgocYMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexsdJ2j4SheDD_OtcIOQmAYUZclVxo94A1A_45jCME8pxBMMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_931WTaTakm8Z7AKYVLJLhErCip4lBfLvAyLnI4T7z09XwMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexvhmfEdrq_QwVq36cWaiRDVTgS6lRQmfznRbVe2I6UscMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_9300oFgZsOlqB35JldPXQn2XtLj_o7IYC3I0vFwNPPriwMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index8iWYRSlhH_45hB3CTHsd4OW_45jFyaQHPVIbayb52o15wTcMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2l55YJH4esRDDCnXOM_C3SN0gEhrraxy_45uwK8KrjB7cMeta } from "/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexsdJ2j4SheDD_OtcIOQmAYUZclVxo94A1A_45jCME8pxBMMeta || {},
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexvhmfEdrq_QwVq36cWaiRDVTgS6lRQmfznRbVe2I6UscMeta || {},
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index8iWYRSlhH_45hB3CTHsd4OW_45jFyaQHPVIbayb52o15wTcMeta || {},
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2l55YJH4esRDDCnXOM_C3SN0gEhrraxy_45uwK8KrjB7cMeta || {},
    component: () => import("/codebuild/output/src1987114454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]